$(() => {
  const RESERVED_PROPERTY = "--place-search-inner-reserved"
  const RESERVED_EVENT = "place-search-inner:reserved"
  const RESERVED_PANEL_CLASS = "place-search-inner_search-results"
  const FIXED_CLASS = "body_place-search-inner-fixed"
  const MAP_CLASS = "google-maps-open"

  // Only the search-results panel is reserved for, and both things that shrink
  // it are switched off for the read: the fixed class (it hides the search form
  // and the chips) and the property itself (it floors the `min-height` of the
  // element being measured). Keep in sync with desktop/place-search-inner.scss,
  // desktop/_base.scss, desktop/search-form.scss and desktop/filter-tags.scss.
  // The un-fix shrinks the page above the reader, so scroll anchoring is held off
  // for the read; it moved the scroll position by a chip row otherwise.
  // https://github.com/halalbooking/halalbooking/pull/30653
  const measure = () => {
    const el = document.querySelector(".place-search-inner")
    if (!el || !el.classList.contains(RESERVED_PANEL_CLASS)) return

    const { classList } = document.body
    if (classList.contains(MAP_CLASS)) return

    const fixed = classList.contains(FIXED_CLASS)
    document.documentElement.style.overflowAnchor = "none"
    classList.remove(FIXED_CLASS)
    document.documentElement.style.removeProperty(RESERVED_PROPERTY)

    const marginBottom = parseFloat(getComputedStyle(el).marginBottom) || 0
    const reserved = el.offsetHeight + marginBottom

    classList.toggle(FIXED_CLASS, fixed)
    document.documentElement.style.setProperty(
      RESERVED_PROPERTY,
      `${reserved}px`,
    )
    document.documentElement.style.overflowAnchor = ""
    $(document).trigger(RESERVED_EVENT)
  }

  let rafId = 0
  const scheduleMeasure = () => {
    if (rafId !== 0) return

    rafId = requestAnimationFrame(() => {
      rafId = 0
      measure()
    })
  }

  $(document).on("fixer:will-fix fixer:released", (_e, selector) => {
    if (selector !== "place-search-inner") return

    measure()
  })

  const footer = document.querySelector(".place-search-inner--footer")
  if (footer) {
    new MutationObserver(scheduleMeasure).observe(footer, {
      childList: true,
      characterData: true,
      subtree: true,
    })
  }

  let mapOpen = document.body.classList.contains(MAP_CLASS)
  new MutationObserver(() => {
    const open = document.body.classList.contains(MAP_CLASS)
    if (open === mapOpen) return

    mapOpen = open
    if (!open) scheduleMeasure()
  }).observe(document.body, { attributeFilter: ["class"] })

  $(window).on("resize", scheduleMeasure)

  $(".layout-offers_show .place-search-inner").fixer(
    "place-search-inner",
    0,
    true,
  )
  $(".place-search-inner--footer").fixer("place-search-inner", 14)
})
